import OrderAddressSearchComponent from "../order/OrderAddressSearchComponent.tsx";

const defaultPrice = 279
const time = '3 mdr.'
const campaignPrice = 199
const min6 = (3 * campaignPrice) + (3 * defaultPrice)

export default function TDC5GHeroComponent() {
    return (
        <div className="hero-container hero-container--5g-internet darkteal">
            <div className="hero-background-wrapper">
                <div className="hero-background"></div>
            </div>
            <div className="hero-content">
                <h1>
                    <span className="hero-unlimited-data">Mobilt bredbånd med fri data</span>
                    <span className="hero-pre-price">Få Danmarks bedste <span className="no-wrap">5G-dækning</span> for kun</span>
                    <span className="hero-price">199<span className="price-comma-dash">,-</span><span className="price-md">/md.<br/>i {time}</span></span>
                    <span className="hero-post-price">Herefter <strong>{defaultPrice},-/md.</strong></span>
                </h1>
            </div>
            <div className="address-wrap">
                <h2>
                    Tjek hvilket tilbud du kan få<span className="scroll-down-arrow"></span>
                </h2>
                <OrderAddressSearchComponent/>
            </div>
            <p className="conditions">
                Tilbuddet gælder kun 5G-internet og for nye kunder.
                Inkl. 5G-lånerouter og fri data.
                Oprettelse 0 kr.
                Binding 6 mdr.
                Min. pris i 6 mdr. {min6} kr.
            </p>
        </div>
    )
}
